"use strict";

var RoutePath = require('../constants/routePath');
var AuthType = require('../constants/auth/authType');

var LOGOU_ACT_AS_QUERY = "?type=" + AuthType.TYPE_ACT_AS;


/**
 * Wrapper for base application routes: login, logout, etc
 * @type {{getLogin: BaseRouteWrapper.getLogin, getLogout: BaseRouteWrapper.getLogout}}
 */
var BaseRouteWrapper = {
  getLogin: function () {
    return RoutePath.ROUTE_LOGIN;
  },

  getLogout: function (moduleName, isActAsLogout) {
    var query = !!isActAsLogout ? LOGOU_ACT_AS_QUERY : "";
    var logoutPath = '/' + RoutePath.ROUTE_LOGOUT + query;
    return logoutPath;
  },


};
module.exports = BaseRouteWrapper;

